import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (_failureCount: number, error: unknown) => {
        const apiError = error as { response?: { status?: number } };
        const status = apiError.response?.status;
        if (status === 401 || status === 403) return false;
        return _failureCount < 3;
      },
      staleTime: 30_000,
    },
    mutations: {
      retry: (failureCount: number, error: unknown) => {
        const apiError = error as { response?: { status?: number }; code?: string };
        const status = apiError.response?.status;
        // Don't retry client errors (4xx)
        if (status && status >= 400 && status < 500) return false;
        // Retry server errors and timeouts up to 1 time
        if (status && status >= 500) return failureCount < 1;
        if (apiError.code === 'ECONNABORTED') return failureCount < 1;
        return false;
      },
    },
  },
});
